import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getData, postData, putData, deleteData } from "../../FetchNodeServices";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import AlertMessages from "../Mains/Alerts";

const EditUser = (props) => {
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  const [fullName, setFullName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [team, setTeam] = useState("");
  const [userType, setUserType] = useState("");
  const [userStatus, setUserStatus] = useState("");
  const [alerts, setAlerts] = useState([]);
  // const [password, setPassword] = useState("");
  const [userId, setUserId] = useState("");
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  // const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  // const [newPassword, setNewPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");

  // const customer = useSelector((state) => state.users[0]);
  // const user = customer.userId;
  const location = useLocation();
  const item = location.state?.item;

  const user = item.userId;
  console.log(item);

  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    
    // General email validation pattern for local part and domain
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    
    // Split the email into parts for more custom validation
    const [localPart, domainPart] = emailValue.split("@");
  
    // General email pattern validation
    if (!emailRegex.test(emailValue)) {
      setEmailError("Invalid email address format");
    } else if (domainPart && domainPart.split(".").length !== 2) {
      // Ensure there's exactly one dot in the domain part (no subdomains)
      setEmailError("Domain should contain only one dot after '@'");
    } else if (domainPart && domainPart.split(".")[1].length < 2 || domainPart.split(".")[1].length > 4) {
      // Ensure the TLD (suffix) is between 2 to 4 characters long
      setEmailError("Domain suffix should be 2 to 4 characters long");
    } else {
      // Clear any previous errors
      setEmailError(null);
    }
    
    setEmailId(emailValue);
  };


  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const handleDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await deleteData("users/delete-user/" + userId);
        if (result) {
          Swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          handleClear();
          navigate("/user-management");
        } else {
          Swal.fire({
            title: "Error!",
            text: "Failed to delete the user.",
            icon: "error",
          });
        }
      }
    });
  };

  useEffect(function () {
    fetchUsers();
  }, []);
  const fetchUsers = async () => {
    let result = await getData("users/get-user/" + user);
    if (result) {
      setUserId(result.userId);
      setFullName(result.fullName);
      setEmailId(result.email);
      setTeam(result.team);
      setUserType(result.userRole);
      setUserStatus(result.status);
      // setPassword(result.password);
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!fullName || !emailId || !team || !userType || !userStatus || emailError) {
      setAlerts([{ variant: "danger", heading: "Please fill all the required fields correctly!" }]);
      return;
    }

    var FormData = { userId: userId, fullName: fullName, email: emailId, team: team, userRole: userType, status: userStatus };
    setIsLoading(true);
    var result = await putData("users/update-user", FormData);
    if (result) {
      // let mail = await postData("users/reset-password/" + userId);
      setIsLoading(false);
      // alert(mail);
      setAlerts([{ variant: "success", heading: "User updated Successfully!" }]);

      // alert("User updated Successfully!");
      navigate("/user-management");
      // handleClear();
    } else {
      // alert("Error in updating User! Try Again Later.");
      setAlerts([{ variant: "danger", heading: "Error in updating User! Try Again Later.." }]);
    }
  };

  const handleClear = () => {
    // setFullName("");
    // setEmailId("");
    // setTeam("");
    // setUserType("");
    // setUserStatus("");
    // setPassword("");
    fetchUsers();
  };

  // const handleResetPassword = () => {
  //   setShowResetPasswordModal(true);
  // };

  // const handleCloseResetPasswordModal = () => {
  //   setShowResetPasswordModal(false);
  //   setNewPassword("");
  //   setConfirmPassword("");
  // };

  // const handleResetPasswordSubmit = async () => {
  //   if (newPassword !== confirmPassword) {
  //     Swal.fire({
  //       title: "Error!",
  //       text: "New password and confirm password do not match.",
  //       icon: "error",
  //     });
  //     return;
  //   } else {
  //     var result = await putData("users/update-password/" + userId + "?newPassword=" + newPassword);
  //     // console.log(result);
  //     setPassword(result);
  //   }
  //   handleCloseResetPasswordModal();
  // };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className={`py-3 ${isLoading ? "blur" : ""}`}>
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> User Management
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i class="bi bi-app-indicator mx-2"></i>User Details
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Full Name</label>
                    <input
                      type="text"
                      value={fullName}
                      className="form-control"
                      placeholder="Enter Full Name"
                      onChange={(event) => setFullName(event.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Email</label>
                    <input type="email" value={emailId} className="form-control" placeholder="Enter email id" onChange={handleEmailChange} />
                    {emailError && <div className="text-danger">{emailError}</div>}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Team</label>
                    <input type="text" value={team} className="form-control" placeholder="Enter team" onChange={(event) => setTeam(event.target.value)} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">User Type</label>
                    <select name="" id="" value={userType} className="form-control" onChange={(event) => setUserType(event.target.value)}>
                      <option value="A">Admin User</option>
                      <option value="U">Standard User</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">User Status</label>
                    <select name="" value={userStatus} id="" className="form-control" onChange={(event) => setUserStatus(event.target.value)}>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                </div>

                {/* <div className="col-lg-4">
                  <div className="form-group mb-4">
                    <label for="">Password</label>
                    <input
                      type="password"
                      value={password}
                      className="form-control"
                      placeholder="******"
                      onChange={(event) => setPassword(event.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-2 mt-4">
                  <button type="button" className="btn bg-success-subtle text-success fs-14" onClick={handleResetPassword}>
                    Reset password
                  </button>
                </div> */}
              </div>

              <div className="d-flex justify-content-between">
                <div className="button_group">
                  <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleDelete()}>
                    Delete User
                  </button>
                </div>
                <div className="button_group">
                  {/* <Link to="/user-management"> */}
                  <button type="button" className="btn btn-success px-4" onClick={() => handleSubmit()}>
                    Update
                  </button>
                  {/* </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className={`modal fade ${showResetPasswordModal ? "show" : ""}`}
        style={{ display: showResetPasswordModal ? "block" : "none" }}
        id="resetPasswordModal"
        tabIndex="-1"
        aria-labelledby="resetPasswordModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="card p-3 border-light-subtle">
              <div className="common_form p-3">
                <div className="row">
                  <div className="col-lg-12 fs-24 text-center text-danger fw-bold mb-4">Reset Password</div>
                  <div className="col-lg-6">
                    <div className="form-group mb-4">
                      <label htmlFor="">New Password</label>
                      <input type="password" className="form-control" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group ">
                      <label htmlFor="">Confirm Password</label>
                      <input type="text" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <button type="button" className="btn bg-danger-subtle text-danger" onClick={handleCloseResetPasswordModal}>
                      Close
                    </button>
                    <button type="button" className="btn bg-success-subtle text-success" onClick={handleResetPasswordSubmit}>
                      Reset Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default EditUser;
